import * as React from 'react'
import clsx from 'clsx'
import { getWeeksInMonth } from '@internationalized/date'
import { useCalendarGrid } from '@react-aria/calendar'

import { Text } from '@wartek-id/text'
import { useId } from '@wartek-id/react-utils'

import { WEEK_DAYS } from 'app/KinerjaShared/components/DatePicker/constants'
import { CalendarCell } from 'app/KinerjaShared/components/DatePicker/CalendarCell'
import styles from 'app/KinerjaShared/components/DatePicker/DatePicker.module.css'

import type { CalendarState, RangeCalendarState } from '@react-stately/calendar'

export interface CalendarGridProps {
  state: RangeCalendarState | CalendarState
}

export function CalendarGrid({ state, ...props }: CalendarGridProps) {
  const { gridProps, headerProps } = useCalendarGrid(props, state as any)
  // Get the number of weeks in the month so we can render the proper number of rows.
  const weeksInMonth = getWeeksInMonth(state.visibleRange.start, 'id-ID')

  const helperId = useId()

  return (
    <table {...gridProps} cellPadding="0" className="flex-1" id={helperId}>
      <thead {...headerProps}>
        <tr>
          {WEEK_DAYS.map((day, index) => (
            <th key={index}>
              <Text
                variant="body-sm"
                color="subdued"
                className={clsx(
                  styles.calendarGridWeekDayText,
                  styles.calendarCellItem
                )}
              >
                {day}
              </Text>
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {Array.from(Array(weeksInMonth).keys()).map((weekIndex) => (
          <tr key={weekIndex}>
            {state
              .getDatesInWeek(weekIndex)
              .map((date, i) =>
                date ? (
                  <CalendarCell key={i} state={state} date={date} />
                ) : (
                  <td key={i} className={styles.calendarCellItem} />
                )
              )}
          </tr>
        ))}
      </tbody>
    </table>
  )
}
